import { FC } from 'react';
import { Box } from '@mui/material';
import DBHeader from 'src/components/Headers/DialogBoxHeader';
import Scrollbar from 'src/components/StyledComponents/StyledScrollbar';
import { PurchaseOrderDialogProps } from 'src/models/DialogBox.interface';
import { PurchaseOrderStatus } from 'src/models/enums/PurchaseOrderStatus.enum';
import {
  SecondaryButton,
  FormTitleTypography,
  FormContentBox,
  ButtonContainerBox,
  StyledCircularProgress,
  ButtonContainerBoxGap,
} from 'src/components/DialogBox/POBox/POBox.styles';
import {
  StyledDialog,
  CloseIcon,
  StyledDialogContent,
  SubmitButton,
} from 'src/components/DialogBox/DialogBox.styles';

const PurchaseOrderDialog: FC<PurchaseOrderDialogProps> = ({
  height = '720px',
  width = '984px',
  open,
  handleClose,
  title,
  subtitle,
  formTitle,
  children,
  onSubmit,
  smScreen,
  buttonLabel = 'Save',
  buttonLabel2,
  buttonWidth = '100px',
  buttonDisabled,
  button1Loading = false,
  button2Loading = false,
  onButtonClick,
}) => {
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      width={width}
      height={height}
    >
      <Box sx={{ position: 'relative' }}>
        <DBHeader title={title} subtitle={subtitle} />
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </Box>
      <Scrollbar thumbColor="var(--loader-color)">
        <StyledDialogContent>
          <form onSubmit={onSubmit}>
            <FormTitleTypography ml={5} mb={2}>
              {formTitle}
            </FormTitleTypography>
            <FormContentBox>{children}</FormContentBox>
            <ButtonContainerBoxGap>
              <SubmitButton
                className="btn-primary"
                type="button"
                disabled={buttonDisabled || button1Loading || button2Loading}
                buttonWidth={buttonWidth}
                onClick={() => onButtonClick?.(PurchaseOrderStatus.NEW)}
              >
                {button1Loading ? (
                  <StyledCircularProgress size={24} />
                ) : (
                  buttonLabel
                )}
              </SubmitButton>
              {buttonLabel2 && (
                <SecondaryButton
                  className="btn-primary"
                  type="button"
                  disabled={buttonDisabled || button1Loading || button2Loading}
                  onClick={() => onButtonClick?.(PurchaseOrderStatus.PENDING)}
                >
                  {button2Loading ? (
                    <StyledCircularProgress size={24} />
                  ) : (
                    buttonLabel2
                  )}
                </SecondaryButton>
              )}
            </ButtonContainerBoxGap>
          </form>
        </StyledDialogContent>
      </Scrollbar>
    </StyledDialog>
  );
};

export default PurchaseOrderDialog;
